/**
 * A passagem de um lugar do prédio para outro (SPEC-20261010-1813), com a
 * marca do Orbind: uma órbita nasce no ponto do clique e abre até cobrir a
 * tela (`abrir`), o lugar troca por baixo, e a órbita se desfaz enquanto o
 * andar novo chega (`fechar`). Só transform e opacidade: rápido e sem
 * engasgo. Substitui o portal em pixel do Minecraft.
 */

export const DURACAO_ABRIR = 220
export const DURACAO_FECHAR = 280

export function Portal({ fase, x, y }: { fase: 'abrir' | 'fechar'; x: number; y: number }) {
  return (
    <div className={`esc__orbita esc__orbita--${fase}`} style={fase === 'abrir' ? { ['--ox' as string]: `${x}px`, ['--oy' as string]: `${y}px` } : undefined} aria-hidden>
      <span className="esc__orbita-veu" />
      <span className="esc__orbita-anel">
        <i className="esc__orbita-lua" />
      </span>
    </div>
  )
}
